// Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/118.0.0.0 Mobile Safari/537.36
// Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/118.0.0.0 Safari/537.36
export function getOperatingSystem() {
  const userAgent = navigator.userAgent.toLowerCase();
  let operatingSystem = "Unknown";
  if (/iphone|ipad|ipod/i.test(userAgent)) {
    operatingSystem = "iOS";
  } else if (/android/i.test(userAgent)) {
    operatingSystem = "Android";
  } else if (/BlackBerry/i.test(userAgent)) {
    operatingSystem = "BlackBerry";
  } else if (/mac/i.test(userAgent)) {
    operatingSystem = "macOS";
  } else if (/win/i.test(userAgent)) {
    operatingSystem = "Windows";
  } else if (/linux/i.test(userAgent)) {
    operatingSystem = "Linux";
  } else if (/bsd/i.test(userAgent)) {
    operatingSystem = "BSD";
  }
  return operatingSystem.toLowerCase();
}

export function getOperatingSystemVersion(ua = navigator.userAgent) {
  let osVersion = "Unknown";
  if (/iPhone|iPad|iPod/i.test(ua)) {
    const match = ua.match(/OS (\d+_\d+)/i);
    if (match) {
      osVersion = match[1].replace("_", ".");
    }
  } else if (/Android/i.test(ua)) {
    const match = ua.match(/Android (\d+\.\d+)/i);
    if (match) {
      osVersion = match[1];
    }
  } else if (/Mac OS X/i.test(ua)) {
    const match = ua.match(/Mac OS X (\d+_\d+)/i);
    if (match) {
      osVersion = match[1].replace("_", ".");
    }
  } else if (/Windows NT/i.test(ua)) {
    const match = ua.match(/Windows NT (\d+\.\d+)/i);
    if (match) {
      osVersion = match[1];
    }
  }
  return osVersion.toLowerCase();
}

export function getBrowserClient() {
  const userAgent = navigator.userAgent.toLowerCase();
  let client = "Unknown";
  if (/opr/i.test(userAgent) || /opera/i.test(userAgent)) {
    client = "Opera";
  } else if (/chrome/i.test(userAgent)) {
    client = "Chrome";
  } else if (/firefox/i.test(userAgent)) {
    client = "Firefox";
  } else if (
    /safari/i.test(userAgent)
    //|| /WebKit/i.test(userAgent)
  ) {
    client = "Safari";
  } else if (/edge/i.test(userAgent)) {
    client = "Edge";
  } else if (/msie|trident/i.test(userAgent)) {
    // client = "Internet Explorer";
    client = "IE";
  } else if (/MicroMessenger/i.test(userAgent)) {
    client = "Wechat";
  } else if (/alipay/i.test(userAgent)) {
    client = "Ali";
  }
  return client.toLowerCase();
}

export function getBrowserClientVersion() {
  const userAgent = navigator.userAgent;
  let browserVersion = "Unknown";
  if (/Chrome/.test(userAgent)) {
    const match = userAgent.match(/Chrome\/(\d+\.\d+)/);
    if (match) {
      browserVersion = match[1];
    }
  } else if (/Firefox/.test(userAgent)) {
    const match = userAgent.match(/Firefox\/(\d+\.\d+)/);
    if (match) {
      browserVersion = match[1];
    }
  } else if (/Safari/.test(userAgent)) {
    const match = userAgent.match(/Version\/(\d+\.\d+)/);
    if (match) {
      browserVersion = match[1];
    }
  } else if (/Edge/.test(userAgent)) {
    const match = userAgent.match(/Edge\/(\d+\.\d+)/);
    if (match) {
      browserVersion = match[1];
    }
  } else if (/MSIE|Trident/.test(userAgent)) {
    const match = userAgent.match(/(?:MSIE|rv:)(\d+\.\d+)/);
    if (match) {
      browserVersion = match[1];
    }
  }
  return browserVersion;
}

export function getBrowserLanguage() {
  return (navigator.browserLanguage || navigator.language).toLowerCase();
}

export function getTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone.toLowerCase();
}

export function isSafari() {
  return getBrowserClient() == "safari";
}

export function isIOS() {
  return getOperatingSystem() === "ios";
}

export function isMacOS() {
  return getOperatingSystem() === "macos";
}

export function isAppleDevice() {
  return isIOS() | isMacOS();
}

export function isAndroid() {
  return getOperatingSystem() === "android";
}

/*
	This should find all Android browsers lower than build 535.19 (both stock browser and webview)
	- galaxy S2 is ok
    - 2.3.6 : `AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Mobile Safari/533.1`
    - 4.0.4 : `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S3 is badAndroid (stock brower, webview)
     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S4 is badAndroid (stock brower, webview)
     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S5 is OK
     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
   - galaxy S6 is OK
     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
  */
export function isBadAndroid() {
  const appVersion = window.navigator.appVersion;
  // Android browser is not a chrome browser.
  if (/Android/.test(appVersion) && !/Chrome\/\d/.test(appVersion)) {
    const safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
    if (
      safariVersion &&
      typeof safariVersion === "object" &&
      safariVersion.length >= 2
    ) {
      return parseFloat(safariVersion[1]) < 535.19;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

export function isMobile() {
  return isIOS() || isAndroid();
}

export function getInternetExplorerVersion() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf("MSIE ");
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
  }
  const trident = ua.indexOf("Trident/");
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf("rv:");
    return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
  }
  const edge = ua.indexOf("Edge/");
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
  }
  // other browser
  return -1;
}

export const isIE = getInternetExplorerVersion() !== -1;
// export function isIE() {
//   return getBrowserClient() === "ie";
// }

export const isIE9 = document.documentMode
  ? document.documentMode === 9
  : false;
export const isIE10 = document.documentMode
  ? document.documentMode === 10
  : false;
export const isIE11 = document.documentMode
  ? document.documentMode === 11
  : false;

export function isWxBrowser() {
  return getBrowserClient() === "wechat";
}

export function isAliBrowser() {
  return getBrowserClient() === "ali";
}

// 是否为微信小程序环境
export function isWxMiniProgram() {
  return (
    (isWxBrowser() && navigator.userAgent.match(/miniprogram/i)) ||
    window.__wxjs_environment === "miniprogram"
  );
}

// 是否为支付宝小程序环境
export function isAliMiniProgram() {
  return isAliBrowser() && navigator.userAgent.match(/miniprogram/i);
}
